import React from "react";
import {logOut} from "../api/auth-api";
import {Button, Container, Navbar, Stack} from "react-bootstrap";
import {useQueryClient} from "react-query";
import {useAuth} from "./AuthProvider";
import {useNavigate} from "react-router-dom";


export const NavigationBar = () => {
  return (
    <Navbar className="bg-body-tertiary mb-3">
      <Container className="PageContentWidth justify-content-between">
        <Navbar.Brand href={"/"}>
          Predictions
        </Navbar.Brand>
        <UserPanel/>
      </Container>
    </Navbar>
  );
}

const UserPanel = () => {
  const {isLoggedIn} = useAuth();

  if (!isLoggedIn) {
    return <Stack direction={"horizontal"} gap={2}>
      <Button href={"/create-account"} variant={"outline-primary"}>Create account</Button>
      <Button href={"/login"} variant={"outline-secondary"}>Log in</Button>
    </Stack>
  }

  return <LogOutButton/>
}

const LogOutButton = () => {
  const {setIsLoggedIn} = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return <Button
    variant="outline-secondary"
    onClick={() => logOut()
      .then(() => setIsLoggedIn(false))
      .then(() => queryClient.invalidateQueries())
      .then(() => navigate("/logged-out"))
    }>Log out
  </Button>
}